var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCircleError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#ff5768"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M7.78 9.5h.44c.1 0 .2-.1.2-.2l.52-3.61V4.24c0-.12-.1-.24-.2-.24H7.26c-.1 0-.2.12-.2.24v1.47l.52 3.59c0 .1.1.2.2.2M7 11.49a1 1 0 0 0 .99 1c.55 0 1.01-.46 1.01-1s-.46-1-1.01-1c-.54 0-.99.46-.99 1"
}))));
export default SvgCircleError;